<template>
  <page-listado>
    <page-header title="Planes">
      <b-button variant="primary" size="sm" to="/planes/crear">
        <v-icon name="plus" width="16" />
        Crear plan
      </b-button>
    </page-header>
    <tabla :planes="planes" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import api from "@/services/planes.js";
import Tabla from "./TablaPlanes.vue";
export default {
  components: { Tabla },
  data() {
    return {
      planes: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return api.listar(this.$route.query).then((planes) => {
        this.planes = planes;
      });
    },
    eliminar(id) {
      api.eliminar(id).then(() => {
        this.listar();
      });
    },
  },
};
</script>
